export function Dot() {
  return (
    <svg style={{minHeight: '24px', minWidth: '24px'}}aria-hidden width={24} height={24} viewBox="0 0 24 24">
      <circle cx={12} cy={12} r={2} fill='currentColor' />
    </svg>
  );
}
